module.exports = __webpack_public_path__ + "img/dollar-general-logo.fea6372f.jpg";